import { useQuery } from 'react-query'
import compress from 'graphql-query-compress'
import { MagentoSearchTerm } from 'lib/types'
import { axiosClient } from 'lib/core/services/magento/client'
import { createHandleSearchTermRouting } from 'lib/modules/misc/utils'
import { usePath, useStoreConfig } from 'lib/core/hooks'
import { useHistory } from 'react-router-dom'

const query = (searchQuery: string) => `
  {
    visitureSearchTerm (query_text: "${encodeURIComponent(searchQuery)}") {
      query_id
      query_text
      num_results
      popularity
      redirect
      store_id
      display_in_terms
      is_active
      is_processed
    }
  }
`

interface Response {
  data: {
    visitureSearchTerm: null | MagentoSearchTerm
  }
}

interface SearchTermSuccessParams {
  searchTerm: MagentoSearchTerm | undefined
  handleSearchTermRouting: (searchTerm: MagentoSearchTerm | undefined) => void
}

interface Params {
  search: string
  onSuccess?: (params: SearchTermSuccessParams) => void
}

export const useSearchTerms = (params: Params) => {
  const history = useHistory()
  const { pwaUrl } = useStoreConfig()
  const { search: searchPath } = usePath()
  const { search, onSuccess } = params
  const _searchQuery = search.trim()
  const handleSearchTermRouting = createHandleSearchTermRouting({
    value: _searchQuery,
    pwaUrl,
    history,
    searchPath
  })

  const { data, isFetching } = useQuery(['useSearchTerms', _searchQuery], async () => {
    return axiosClient(compress(query(_searchQuery)))
  }, {
    onSuccess: (data) => {
      const res = data?.data as Response | undefined
      const searchTerm = res?.data.visitureSearchTerm
      onSuccess?.({
        searchTerm: searchTerm ?? undefined,
        handleSearchTermRouting
      })
    },
    enabled: !process.env.REACT_APP_DISABLE_SEARCH_TERMS
  })

  const res = data?.data as Response | undefined
  const searchTerm = res?.data.visitureSearchTerm

  return {
    searchTerm: searchTerm ?? undefined,
    isFetching
  }
}
